<ng-container *transloco="let t; prefix: 'labels'">
  @for (label of itemLabels; track labelTracker(label)) {
    <app-item-label
      [label]="label"
      [itemType]="item().type"
      size="large"
      (click)="onLabelClicked(label)"
    ></app-item-label>
  }
  @if (newLabel) {
    <app-item-label [label]="newLabel" [itemType]="item().type" size="large"></app-item-label>
  }
  @if (!isReadOnly()) {
    <div class="item-labels__add-button-container">
      <xi-default-button
        #addLabelButton
        [text]="t('add-label')"
        fill="text"
        iconLeft="add_circle"
        (onClick)="onAddLabelClicked()"
      ></xi-default-button>
    </div>
  }
</ng-container>

@if (isLabelEditorVisible) {
  <app-lex-xi-popout
    [isVisible]="isLabelEditorVisible"
    [element]="addLabelButton().nativeElement"
    (close)="onLabelEditorClosed()"
  >
    <ng-template appXIPopoutContent>
      @if (isLabelEditorVisible) {
        <app-edit-label-popout
          [item]="item()"
          [label]="updatedLabel"
          [objectType]="objectType"
          [objectLabels]="itemLabels"
          (labelTextUpdating)="onLabelTextUpdating($event)"
          (labelUpdated)="onLabelUpdated($event)"
          (labelApplied)="onLabelApplied($event)"
          (labelRemoved)="onLabelRemoved($event)"
          (cancel)="onLabelEditorClosed()"
        ></app-edit-label-popout>
      }
    </ng-template>
  </app-lex-xi-popout>
}
